import classNames from "classnames"
import React from "react"
import ProductDiscountBadge from "../ProductBadges/ProductDiscountBadge"

export interface ExtraDiscountBadgesProps {
  extraDiscountPercent?: number
  className?: string
  height?: number
}

const ExtraDiscountBadges = ({
  extraDiscountPercent,
  className,
  height,
}: ExtraDiscountBadgesProps) => {
  return (
    <>
      {extraDiscountPercent ? (
        <ProductDiscountBadge
          className={classNames("!bg-black !text-white", className)}
          discountPercent={extraDiscountPercent}
          height={height}
        />
      ) : undefined}
    </>
  )
}

export default ExtraDiscountBadges
